<app-breadcrumb [breadcrumb]="'terms-conditions'" [title]="'terms-conditions'"></app-breadcrumb>
<!-- about section start -->
<div class="about-page section-b-space">
    <div class="container">
        <div class="row">
            <div class="col-sm-12">
                <h4>Disclaimer</h4>
                <ol class="terms-conditions">
                    <li>
                        <b>General Disclaimer</b> <br/>
                        Dear Customer, <br/>
                        <p>
                            Your order is valuable to us. We would like you to understand and appreciate how much we
                            care
                            about your orders. Please go through the disclaimers and stay informed. We reserve the right
                            to
                            refuse any order unconditionally.
                        </p>
                    </li>
                    <li>
                        <b>Shipping & Delivery Disclaimer</b> <br/>
                        Dear Customer, <br/>
                        <p>
                            All courier orders are carefully packed and shipped from our warehouse. Soon after the order
                            has
                            been dispatched, you will receive a tracking number that will help you trace your order.
                            Also,
                            we request you to take a video while opening your product. If there is any damage in
                            transit, please
                            share the video with us. We will replace the damaged product.
                        </p>
                        <p>
                            Giftoholics provide the best service in terms of quality and value. We give the best quality
                            print on all our customized products. However, there may be a little variation or little
                            changes
                            in the final outcome of the products.
                        </p>
                        <p>
                            Once the order is placed, we immediately start working on it so we do not entertain any
                            changes
                            on the products post order placement.
                        </p>
                        <p>
                            Please note that usually, customized products take a longer time in the making process so
                            the
                            delivery period is longer than normal products. In case of early delivery, please get in
                            touch
                            on <a href="tel: +918905253279">8905253279</a> or email to
                            <a href="mailto:giftoholics.handmade@gmail.com">giftoholics.handmade@gmail.com</a>.
                        </p>
                        <p>
                            The products will be delivered through a courier company and the delivery made by them are
                            subject to the Terms and Conditions of such courier companies. For products that are shipped
                            using the services of our courier partners, the date of delivery is an estimate. Your order
                            may
                            be delivered before or after the chosen date of delivery. You acknowledge that the requested
                            delivery date is non-binding. The estimated delivery date depends on the availability of the
                            product and the destination to which you want the product to be shipped. Our courier
                            partners do
                            not call before delivering an order, so we recommend that you provide an address at which
                            someone will be present to receive the package. The delivery cannot be redirected to any
                            other
                            address.
                        </p>
                        <p>
                            Delivery may take longer due to:</p>
                        <ul class="delivery-issues">
                            <li>Bad weather</li>
                            <li>Political disruptions</li>
                            <li>Based on location</li>
                            <li>Holidays or strike</li>
                            <li>Other unforeseen circumstances</li>
                        </ul>
                        <p>
                            In such cases, we will proactively reach out to you. Please check your e-mails and messages
                            regularly for updates.
                        </p>
                        <p>
                            Before major occasions, we suggest that you place your order at least five days in
                            advance.
                        </p>
                    </li>
                    <li>
                        <b>How to customize an order?</b> <br/>
                        <p>
                            Once completing the successful payment process, Giftoholics will send an email to the
                            registered
                            email id provided by the customer asking for personalized requirements like photographs,
                            names,
                            text, or color as per available options. Customers are requested to attach all the required
                            information for the best service.
                            Also, our executive will get in touch on the registered contact number provided by the
                            customer
                            in case any details aren't clear to us.
                        </p>
                    </li>
                </ol>
            </div>
        </div>
    </div>
</div>
